<template>
    <div class="computerBox">
        <topBox :title="title" />
        <div class="px-[36px] w-full mt-[80px] pb-[70px]">
            <p v-if="description" class="mb-3 text-14 font-semibold text-slate-400 leading-relaxed">{{ description }}</p>

            <div class="rounded-[20px] border bg-white px-[20px] py-[12px] shadow-lg text-center mb-4">
                <div class="text-14 text-slate-400">{{ $t('text.totalAccountCount') }}</div>
                <div class="mt-1 text-m14 font-semibold text-slate-900">{{ total }}</div>
            </div>

            <van-list
                v-model:loading="loading"
                :finished="finished"
                :immediate-check="true"
                :finished-text="$t('text.noMore')"
                @load="onLoad"
            >
                <div
                    v-for="item in list"
                    :key="item.member_id"
                    class="member-item"
                >
                    <div class="flex items-center justify-between gap-3">
                        <div class="min-w-0">
                            <div class="text-m14 font-semibold text-slate-900 truncate">{{ item.account }}</div>
                            <div class="mt-1 text-12 text-slate-400">
                                {{ $t('text.registerTime') }}：{{ date(item.created_at) }} {{ time(item.created_at) }}
                            </div>
                        </div>
                        <div class="shrink-0 text-14 font-semibold text-slate-500">层级 {{ item.rank -1 }}</div>
                    </div>
                </div>
            </van-list>

            <div v-if="finished && list.length === 0" class="py-10 text-center text-sm text-slate-400">
                {{ $t('text.noReferralMembers') }}
            </div>
        </div>
        <mainMenu />
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import topBox from '@/components/computer/TopBox.vue'
import mainMenu from '@/components/computer/MainMenu.vue'
import format from '@/assets/js/formatDate'
import postPages from '@/assets/js/postPages'
import { layer } from 'vue3-layer'

export default {
    components: {
        topBox,
        mainMenu,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            default: '',
        },
        apiUrl: {
            type: String,
            required: true,
        },
    },
    setup() {
        return {
            ...format(),
        }
    },
    data() {
        return {
            lang: '',
            list: [],
            total: 0,
            pageNumber: 1,
            pageSize: 20,
            loading: false,
            finished: false,
        }
    },
    mounted() {
        const { locale } = useI18n()
        this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : locale.value
        locale.value = this.lang
    },
    methods: {
        onLoad() {
            const page = postPages(
                this.lang,
                localStorage.getItem('token'),
                this.apiUrl,
                this.pageSize,
                this.pageNumber,
                ''
            )
            page.data.then((res) => {
                if (res && res.code === 0) {
                    const items = res.data.items || []
                    this.total = res.data.total || 0
                    items.forEach((item) => {
                        this.list.push(item)
                    })
                    this.loading = false
                    this.pageNumber++
                    if (this.list.length >= this.total) {
                        this.finished = true
                    }
                } else {
                    this.loading = false
                    this.finished = true
                    if (res) layer.msg(res.msg)
                }
            }).catch(() => {
                this.loading = false
                this.finished = true
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.computerBox {
    background: url('https://tdkt06.com/img/headbg2x.1c5aca6e.png') 0% 0% / 100% no-repeat;
}

.member-item {
    padding: 14px 16px;
    margin-bottom: 10px;
    border-radius: 16px;
    background: #fff;
    border: 1px solid #e5e7eb;
    box-shadow: 0 4px 6px -4px rgba(0, 0, 0, 0.08);
}
</style>
